import { create } from "zustand";

import type { ItemCacheIdentity } from "@memorang/features/src/qa-search/types";
import type { OriginalQuestionData } from "@memorang/features/src/qa-search/types/question";

type State = {
	itemId?: string;
	userPrompt: string;
	cacheIdentity?: ItemCacheIdentity | null;
	selectedQuery: string;
	showDrawer: boolean;
	isItemAnswered: boolean;
	originalQuestionData?: OriginalQuestionData;
	updateItemId: (itemId: string) => void;
	updateUserPrompt: (prompt: string) => void;
	updateCacheIdentity: (identity: ItemCacheIdentity | null | undefined) => void;
	updateSelectedQuery: (query: string) => void;
	updateShowDrawer: (show: boolean) => void;
	updateIsItemAnswered: (isDisabled: boolean) => void;
	updateOriginalQuestionData: (data: OriginalQuestionData | undefined) => void;
};

export const useAilaStore = create<State>()((set) => ({
	itemId: undefined,
	userPrompt: "",
	cacheIdentity: undefined,
	selectedQuery: "",
	showDrawer: false,
	isItemAnswered: false,
	originalQuestionData: undefined,
	updateItemId: (itemId: string) => set({ itemId }),
	updateUserPrompt: (userPrompt: string) => set({ userPrompt }),
	updateCacheIdentity: (cacheIdentity) => set({ cacheIdentity }),
	updateSelectedQuery: (selectedQuery: string) => set({ selectedQuery }),
	updateShowDrawer: (showDrawer: boolean) => set({ showDrawer }),
	updateIsItemAnswered: (isItemAnswered) => set({ isItemAnswered }),
	updateOriginalQuestionData: (originalQuestionData) =>
		set({ originalQuestionData }),
}));
